import React from "react";

const InfoMessages = ({ messages }) => {
    return (
        <React.Fragment>
            <div className="text-center border border-info rounded p-5 fs-4 bg-info m-3">
                {messages}
            </div>
        </React.Fragment>
    )
}
export default InfoMessages;